<ng-container *ngIf="sections$ | async; let sections; else: loading">
    <ng-container *ngIf="selectedView == 'grid'">
        <div
            fxLayout="column"
            infinite-scroll
            [scrollWindow]="true"
            (scrolled)="requestNextSectionsPage()"
            [infiniteScrollDistance]="scrollDistance"
            [infiniteScrollUpDistance]="scrollUpDistance"
            [infiniteScrollThrottle]="throttle"
        >
            <div *ngFor="let section of sections" fxLayout="column">
                <ng-container *ngIf="!emptySections.includes(section.id)">
                    <div class="expand-wrapper" fxLayout="row" fxLayoutAlign="space-between center">
                        <span class="scope-label">{{ section.title }}</span>
                        <button
                            mat-icon-button
                            class="expand-btn"
                            (click)="scopesExpansions[section.id] = !scopesExpansions[section.id]"
                        >
                            <mat-icon>{{ scopesExpansions[section.id] ? 'unfold_less' : 'unfold_more' }}</mat-icon>
                        </button>
                    </div>

                    <app-resources-grid-base
                        [class.collapsed]="!scopesExpansions[section.id]"
                        [tableFilterItems]="[
                            { property: 'published', items: [1] },
                            { property: 'section', items: [section.id] }
                        ]"
                        [guestMode]="true"
                        [sectionId]="section.id"
                        (onEmptyResources)="onEmptySections(section.id)"
                    ></app-resources-grid-base>
                </ng-container>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="selectedView == 'list'">
        <div
            fxLayout="column"
            fxLayoutGap="1em"
            infinite-scroll
            [scrollWindow]="true"
            (scrolled)="requestNextSectionsPage()"
            [infiniteScrollDistance]="scrollDistance"
            [infiniteScrollUpDistance]="scrollUpDistance"
            [infiniteScrollThrottle]="throttle"
        >
            <div *ngFor="let section of sections" fxLayout="column">
                <div class="mt-1 expand-wrapper" fxLayout="row" fxLayoutAlign="space-between center">
                    <span class="scope-label">{{ section.title }}</span>
                    <button
                        mat-icon-button
                        class="expand-btn"
                        (click)="scopesExpansions[section.id] = !scopesExpansions[section.id]"
                    >
                        <mat-icon>{{ scopesExpansions[section.id] ? 'unfold_less' : 'unfold_more' }}</mat-icon>
                    </button>
                </div>
                <!-- <app-overview-activity-list
                    [class.collapsed]="!scopesExpansions[section.id]"
                    [user]="user$ | async"
                    [pageSizeOptions]="[5, 20, 50]"
                    matSortActive="updated_at"
                    [tableFilterItems]="[
                        { property: 'published', items: [1] },
                        { property: 'eager', items: ['enrollment,user_collaboration'] },
                        { property: 'section', items: [section.id] },
                        { property: 'limit', items: [5] }
                    ]"
                ></app-overview-activity-list> -->
            </div>
        </div>
    </ng-container>
    <!-- <div *ngIf="totalPages - 1 > currentSectionsPage" fxLayout="row" fxLayoutAlign="center center">
        <app-kd-logo-loading></app-kd-logo-loading>
    </div> -->
</ng-container>

<ng-template #loading>
    <div fxLayout="row" fxLayoutAlign="center center">
        <app-kd-logo-loading></app-kd-logo-loading>
    </div>
</ng-template>
